export const maskPhoneNumber = (phoneStr) => {
  if (!phoneStr) return "-";

  const str = String(phoneStr);
  if (str.length >= 10) return str.slice(0, 2) + "XXXXX" + str.slice(7);
  if (str.length > 2) return "x".repeat(str.length - 2) + str.slice(-2);

  return str;
};

export const getCallIdFromResponse = (res) =>
  res?.call_id || res?.callId || res?.data?.call_id || res?.data?.callId || "";

export const getOtpCodeFromResponse = (res) =>
  res?.otpCode || res?.data?.otpCode || res?.otp_code || res?.data?.otp_code;
